export default __webpack_public_path__ + "static/media/Conscript's Gauntlets of the Shining Sun.ef371208.jpg";